export const DEFAULT_CREDIT_CONFIG = {
  topUpTypes: [],
}
